import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "card-body" }
const _hoisted_3 = { class: "form-group row" }
const _hoisted_4 = { class: "col-lg-6" }
const _hoisted_5 = { class: "col-lg-6" }
const _hoisted_6 = { class: "form-group row" }
const _hoisted_7 = { class: "col-lg-6" }
const _hoisted_8 = { class: "col-sm-6" }
const _hoisted_9 = { class: "form-group row" }
const _hoisted_10 = { class: "col-sm-6" }
const _hoisted_11 = { class: "col-sm-6" }
const _hoisted_12 = { class: "form-group row" }
const _hoisted_13 = { class: "col-sm-12" }
const _hoisted_14 = { class: "form-group row" }
const _hoisted_15 = { class: "col-sm-12" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", { class: "h4 pb-2 mb-4 text-danger border-bottom border-danger" }, "Sobre las Inscripciones", -1)
const _hoisted_17 = { class: "form-group row mb-2" }
const _hoisted_18 = { class: "col-sm-6" }
const _hoisted_19 = { class: "col-sm-6" }
const _hoisted_20 = { class: "row row-cols-2 mb-3 g-10" }
const _hoisted_21 = { class: "col d-flex align-items-center justify-content-between" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("label", null, "Nivel de acceso", -1)
const _hoisted_23 = { class: "col d-flex align-items-center justify-content-between" }
const _hoisted_24 = { class: "row row-cols-2 g-10" }
const _hoisted_25 = { class: "col d-flex align-items-center justify-content-between" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("div", { class: "col d-flex align-items-center justify-content-between" }, null, -1)
const _hoisted_27 = { class: "dialog-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_switch = _resolveComponent("el-switch")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_scrollbar = _resolveComponent("el-scrollbar")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    title: _ctx.titleDialog,
    modelValue: _ctx.isModalVisible,
    "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.isModalVisible) = $event)),
    class: "bg-light rounded",
    onOpen: _ctx.onOpen,
    onOpened: _ctx.onOpened,
    onClosed: _ctx.onClosed,
    "close-on-click-modal": false,
    "close-on-press-escape": false,
    "lock-scroll": "",
    draggable: "",
    "destroy-on-close": true,
    top: "1vh"
  }, {
    footer: _withCtx(() => [
      _createElementVNode("div", _hoisted_27, [
        _createVNode(_component_el_button, {
          onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.isModalVisible = false)),
          text: ""
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.t('cancel')), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_button, {
          type: "primary",
          loading: _ctx.loading,
          onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.submitForm(_ctx.ruleFormRef)))
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.itemEvent?.idevent ? _ctx.t('update') : _ctx.t('save')), 1)
          ]),
          _: 1
        }, 8, ["loading"])
      ])
    ]),
    default: _withCtx(() => [
      _createVNode(_component_el_scrollbar, {
        ref: "scrollRef",
        height: _ctx.altura,
        always: true
      }, {
        default: _withCtx(() => [
          _createElementVNode("pre", null, _toDisplayString(_ctx.itemEvent), 1),
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _withDirectives((_openBlock(), _createBlock(_component_el_form, {
                ref: "ruleFormRef",
                model: _ctx.form,
                "status-icon": "",
                rules: _ctx.rules,
                "label-position": "top"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, {
                    prop: "name",
                    label: _ctx.t('name')
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.form.name,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.name) = $event)),
                        onKeyup: _ctx.getUrl
                      }, null, 8, ["modelValue", "onKeyup"])
                    ]),
                    _: 1
                  }, 8, ["label"]),
                  _createElementVNode("div", _hoisted_3, [
                    _createElementVNode("div", _hoisted_4, [
                      _createVNode(_component_el_form_item, {
                        prop: "tipo",
                        label: _ctx.t('tipo')
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_select, {
                            modelValue: _ctx.form.tipo,
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.tipo) = $event)),
                            placeholder: _ctx.t('select')
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listTypes, (item) => {
                                return (_openBlock(), _createBlock(_component_el_option, {
                                  key: `t-${item.id}`,
                                  label: item.name,
                                  value: item.id
                                }, null, 8, ["label", "value"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["modelValue", "placeholder"])
                        ]),
                        _: 1
                      }, 8, ["label"])
                    ]),
                    _createElementVNode("div", _hoisted_5, [
                      _createVNode(_component_el_form_item, {
                        prop: "level",
                        label: _ctx.t('categorie')
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_select, {
                            modelValue: _ctx.form.level,
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.level) = $event)),
                            placeholder: _ctx.t('select')
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listCategorie, (item) => {
                                return (_openBlock(), _createBlock(_component_el_option, {
                                  key: `c-${item.id}`,
                                  label: item.name,
                                  value: item.id
                                }, null, 8, ["label", "value"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["modelValue", "placeholder"])
                        ]),
                        _: 1
                      }, 8, ["label"])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("div", _hoisted_7, [
                      _createVNode(_component_el_form_item, {
                        prop: "modality",
                        label: _ctx.t('modality')
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_select, {
                            modelValue: _ctx.form.modality,
                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.form.modality) = $event)),
                            placeholder: _ctx.t('select')
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listModality, (item) => {
                                return (_openBlock(), _createBlock(_component_el_option, {
                                  key: `d-${item.id}`,
                                  label: item.name,
                                  value: item.id
                                }, null, 8, ["label", "value"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["modelValue", "placeholder"])
                        ]),
                        _: 1
                      }, 8, ["label"])
                    ]),
                    _createElementVNode("div", _hoisted_8, [
                      _createVNode(_component_el_form_item, {
                        prop: "startdate",
                        label: _ctx.t('dateStart')
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_date_picker, {
                            modelValue: _ctx.form.startdate,
                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.form.startdate) = $event)),
                            class: "w-100",
                            type: "date",
                            placeholder: _ctx.t('select'),
                            "value-format": "YYYY-MM-DD",
                            format: "DD/MM/YYYY"
                          }, null, 8, ["modelValue", "placeholder"])
                        ]),
                        _: 1
                      }, 8, ["label"])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("div", _hoisted_10, [
                      _createVNode(_component_el_form_item, {
                        prop: "idseat",
                        label: _ctx.t('sede')
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_select, {
                            modelValue: _ctx.form.idseat,
                            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.form.idseat) = $event)),
                            filterable: "",
                            placeholder: _ctx.t('select')
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listSeats, (item) => {
                                return (_openBlock(), _createBlock(_component_el_option, {
                                  key: `lr-${item.idseat}`,
                                  label: item.name,
                                  value: item.idseat
                                }, null, 8, ["label", "value"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["modelValue", "placeholder"])
                        ]),
                        _: 1
                      }, 8, ["label"])
                    ]),
                    _createElementVNode("div", _hoisted_11, [
                      _createVNode(_component_el_form_item, {
                        prop: "enddate",
                        label: _ctx.t('dateEnd')
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_date_picker, {
                            modelValue: _ctx.form.enddate,
                            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.form.enddate) = $event)),
                            class: "w-100",
                            type: "date",
                            placeholder: _ctx.t('select'),
                            "value-format": "YYYY-MM-DD",
                            format: "DD/MM/YYYY"
                          }, null, 8, ["modelValue", "placeholder"])
                        ]),
                        _: 1
                      }, 8, ["label"])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_12, [
                    _createElementVNode("div", _hoisted_13, [
                      _createVNode(_component_el_form_item, {
                        prop: "place",
                        label: _ctx.t('place')
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_input, {
                            modelValue: _ctx.form.place,
                            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.form.place) = $event))
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      }, 8, ["label"])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_14, [
                    _createElementVNode("div", _hoisted_15, [
                      _createVNode(_component_el_form_item, {
                        prop: "slug",
                        label: _ctx.t('urlFriendly'),
                        rules: [
                                            {required: true, message: _ctx.t('obligatorie')}
                                        ]
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_input, {
                            modelValue: _ctx.form.slug,
                            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.form.slug) = $event))
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      }, 8, ["label", "rules"])
                    ])
                  ]),
                  _hoisted_16,
                  _createElementVNode("div", _hoisted_17, [
                    _createElementVNode("div", _hoisted_18, [
                      _createVNode(_component_el_form_item, {
                        prop: "allowed_max",
                        label: _ctx.t('yearMax'),
                        rules: [
                                            { required: true, message: _ctx.t('obligatorie') },
                                            { type: 'number', message: _ctx.t('enterToNumber') },
                                        ]
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_input, {
                            modelValue: _ctx.form.allowed_max,
                            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.form.allowed_max) = $event)),
                            modelModifiers: { number: true },
                            maxlength: "4",
                            minlength: "4"
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      }, 8, ["label", "rules"])
                    ]),
                    _createElementVNode("div", _hoisted_19, [
                      _createVNode(_component_el_form_item, {
                        prop: "allowed_min",
                        label: _ctx.t('yearMin'),
                        rules: [
                                            { required: true, message: _ctx.t('obligatorie') },
                                            { type: 'number', message: _ctx.t('enterToNumber') },
                                        ]
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_input, {
                            modelValue: _ctx.form.allowed_min,
                            "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.form.allowed_min) = $event)),
                            modelModifiers: { number: true },
                            maxlength: "4",
                            minlength: "4"
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      }, 8, ["label", "rules"])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_20, [
                    _createElementVNode("div", _hoisted_21, [
                      _hoisted_22,
                      _createVNode(_component_el_form_item, {
                        prop: "access",
                        class: "m-0"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_switch, {
                            modelValue: _ctx.form.access,
                            "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.form.access) = $event)),
                            size: "large",
                            "inline-prompt": "",
                            style: {"--el-switch-off-color":"#a1a5b7"},
                            "active-text": _ctx.t('public'),
                            "inactive-text": _ctx.t('private'),
                            "active-value": "1",
                            "inactive-value": "0"
                          }, null, 8, ["modelValue", "active-text", "inactive-text"])
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("div", _hoisted_23, [
                      _createElementVNode("label", null, _toDisplayString(_ctx.t('activeForms')), 1),
                      _createVNode(_component_el_form_item, {
                        prop: "forms",
                        class: "m-0"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_switch, {
                            modelValue: _ctx.form.forms,
                            "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.form.forms) = $event)),
                            size: "large",
                            "inline-prompt": "",
                            style: {"--el-switch-off-color":"#a1a5b7"},
                            "active-text": _ctx.t('yes'),
                            "inactive-text": "NO",
                            "active-value": "1",
                            "inactive-value": "0"
                          }, null, 8, ["modelValue", "active-text"])
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_24, [
                    _createElementVNode("div", _hoisted_25, [
                      _createElementVNode("label", null, _toDisplayString(_ctx.t('activeRegister')), 1),
                      _createVNode(_component_el_form_item, {
                        prop: "register",
                        class: "m-0"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_switch, {
                            modelValue: _ctx.form.register,
                            "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.form.register) = $event)),
                            size: "large",
                            "inline-prompt": "",
                            style: {"--el-switch-off-color":"#a1a5b7"},
                            "active-text": _ctx.t('yes'),
                            "inactive-text": "NO",
                            "active-value": "1",
                            "inactive-value": "0"
                          }, null, 8, ["modelValue", "active-text"])
                        ]),
                        _: 1
                      })
                    ]),
                    _hoisted_26
                  ])
                ]),
                _: 1
              }, 8, ["model", "rules"])), [
                [_directive_loading, _ctx.loader]
              ])
            ])
          ])
        ]),
        _: 1
      }, 8, ["height"])
    ]),
    _: 1
  }, 8, ["title", "modelValue", "onOpen", "onOpened", "onClosed"]))
}